import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_NAV_PERFORMANCE_API =
  'INVESTMENT/FETCH_PORTFOLIO_NAV_PERFORMANCE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_NAV_PERFORMANCE_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/nav-performance`,
    method: 'GET',
  })
);

export default apiCall;
